import { TranslateService } from '@ngx-translate/core';
import { CallState } from '../../models/test-run.model';
import { conditionsText } from './condition-text';

/*
 * Der Server speichert den Grund eines abgelehnten Aufrufs als deutschen Text in `note`/`comment`;
 * ein Feld fuer die Art des Grunds gibt es nicht. Die Texte muessen wortgleich mit den BE-Konstanten
 * bleiben, die `CallReasonTextsTest` und `RunnerExpansionApplierTest` festhalten. Aendert sich einer,
 * faellt die Ansicht still auf den Server-Text zurueck.
 */
/** `RunnerExpansionApplier.DECLINED_AUTOMATICALLY` */
export const DECLINED_AUTOMATICALLY = 'Bedingung im automatischen Lauf verneint';
/** `TestRunRunnerService.DECLINED_MANUALLY` */
export const DECLINED_MANUALLY = 'Bedingung im manuellen Lauf verneint';
/** `CallExpansionService.NOT_REACHED` */
export const NOT_REACHED = 'nicht erreicht';

/**
 * Warum ein Aufruf nicht lief (NEX-2282). Die drei bekannten Gruende sind uebersetzt, jeder andere
 * Server-Text („Schleife beendet nach Runde 3", „keine Zeile gewählt", Grenz-Meldungen) bleibt wie er ist.
 */
export function callReason(
  callState: CallState | null | undefined,
  note: string | null | undefined,
  conditions: Record<string, string>[] | undefined,
  translate: TranslateService,
): string {
  if (callState === 'OPEN') return translate.instant('runTree.reason.open');
  const text = note?.trim();
  switch (text) {
    case undefined:
    case '':
      return translate.instant('runTree.reason.skipped');
    case DECLINED_AUTOMATICALLY: {
      const condition = conditionsText(conditions, translate);
      return condition
        ? translate.instant('runTree.reason.conditionFalseWith', { condition })
        : translate.instant('runTree.reason.conditionFalse');
    }
    case DECLINED_MANUALLY:
      return translate.instant('runTree.reason.declinedManual');
    case NOT_REACHED:
      return translate.instant('runTree.reason.notReached');
    default:
      return text;
  }
}

/** Die Zeile eines nicht ausgefuehrten Aufrufs: „TM_Fehlerbehandlung – nicht erreicht". */
export function callLine(
  moduleName: string | null | undefined,
  callState: CallState | null | undefined,
  note: string | null | undefined,
  conditions: Record<string, string>[] | undefined,
  translate: TranslateService,
): string {
  return translate.instant('runTree.callLine', {
    module: moduleName?.trim() || translate.instant('runPath.untitledModule'),
    reason: callReason(callState, note, conditions, translate),
  });
}
